import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { useSelector } from "react-redux";
import HomePage from "./views/app/homePages/HomePage";
import Destination from "./views/app/destination/Destination";
import DetailIsland from "./views/app/destination/components/detaildestination/detailIsland/DetailIsland";
import DetailProvince from "./views/app/destination/components/detaildestination/detailProvince/DetailProvince";
import DetailYacht from "./views/app/yacht/components/detailYacht/DetailYacht";
import Contact from "./views/app/contact/Contact";
import Become from "./views/app/become/Become";
import TestPage from "./views/app/testpage/testpage";
import Yacht from "./views/app/yacht/Yacht";
import BookingInquiry from "./views/app/booking/BookingInquiry";
import "./i18n.js";
import ScrollToTop from "./ScrollToTop";
import UserInformation from "./views/app/infomation/UserInformation.js";
import CookiePolicy from "./components/CookiePolicy";
import Cookiepolicy from "./views/app/cookie/Cookiepolicy";
import EmailActionPage from "./views/app/infomation/components/EmailAction.js";
import RefundRequest from "./views/app/refundRequest/RefundRequest";

const ProtectedRoute = ({ isAuthenticated, element }) => {
  return isAuthenticated ? (
    element
  ) : (
    <Navigate to="/" replace state={{ openLoginModal: true }} />
  );
};

function App() {
  const isAuthenticated = useSelector(
    (state) => state.AuthSlice.isAuthenticated
  );

  return (
    <Router>
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/destination" element={<Destination />} />
        <Route path="/yacht" element={<Yacht />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/become-a-partner" element={<Become />} />
        <Route path="/cookiePolicy" element={<Cookiepolicy />} />
        <Route path="/termsConditions" element={<Cookiepolicy />} />
        <Route path="/privacyPolicy" element={<Cookiepolicy />} />
        <Route path="/refundPolicy" element={<Cookiepolicy />} />
        <Route path="/about" element={<Cookiepolicy />} />
        <Route path="/dataDeletionPolicy" element={<Cookiepolicy />} />
        <Route path="/testpage" element={<TestPage />} />
        <Route path="/email-action" element={<EmailActionPage />} />
        <Route
          path="/userinformation"
          element={
            <ProtectedRoute
              isAuthenticated={isAuthenticated}
              element={<UserInformation />}
            />
          }
        />

        <Route
          path="/destination/detailIsland/:slug"
          element={<DetailIsland />}
        />
        <Route
          path="/destination/detailProvince/:slug"
          element={<DetailProvince />}
        />
        {/* <Route path="/yacht/:desName" element={<Yacht />} /> */}
        <Route path="/yacht/detailYacht/:slug" element={<DetailYacht />} />
        <Route path="/yacht/:desName/:rateType" element={<Yacht />} />
        <Route path="/yacht/:desName/:rateType/:date" element={<Yacht />} />
        {/* <Route path="/yacht/:id" element={<DetailYacht />} /> */}
        <Route path="/bookingInquiry/:slug" element={<BookingInquiry />} />
        <Route path="/rights-request" element={<RefundRequest />} />
      </Routes>

      <CookiePolicy />
    </Router>
  );
}

export default App;
